var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flex',[_c('Flex',[_vm._v(_vm._s(_vm.$t('label.numberOfWords')))]),_c('DropDown',{attrs:{"options":_vm.getSubOptions(),"selectedOptionIndex":_vm.selectedSubOptionIndex},on:{"updateOption":_vm.onSubOptionUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }